import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-94b1c1d4")

_pushScopeId("data-v-94b1c1d4")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "order-status flex" }
const _hoisted_3 = {
  key: 0,
  class: "flex alignC top-button-group"
}
const _hoisted_4 = { class: "mar-r-8" }
const _hoisted_5 = { class: "mar-r-8" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "单位", -1)
const _hoisted_7 = { class: "mar-r-8" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "合作方", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "导出", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "加到批量回款", -1)
const _hoisted_11 = {
  key: 1,
  class: "flex alignC top-button-group"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "从批量回款中移除", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "批量回款", -1)
const _hoisted_14 = { class: "flex flexR mar-t-22" }
const _hoisted_15 = { style: {"width":"280px"} }
const _hoisted_16 = { style: {"width":"280px"} }
const _hoisted_17 = { style: {"width":"280px"} }
const _hoisted_18 = { class: "flex flexC" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, /*#__PURE__*/_toDisplayString('保存'), -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", {
        class: { 'mar-r-20 f-14 mouse_point': true, 'nav-range c-red': _ctx.NavIndex == 0 },
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.NavIndex = 0))
      }, "应收明细", 2),
      _createVNode("p", {
        class: { 'mar-r-20 f-14 mouse_point': true, 'nav-range c-red': _ctx.NavIndex == 2 },
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.NavIndex = 2))
      }, "批量回款", 2)
    ]),
    (_ctx.NavIndex == 0)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.screenParameter.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.type = $event)),
              placeholder: "请选择",
              clearable: "",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectChange($event, 'status'))),
              class: "mar-r-8",
              style: {"width":"114px"}
            }, {
              default: _withId(() => [
                _createVNode(_component_el_option, {
                  label: "开单时间",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "结算时间",
                  value: 2
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.screenParameter.time,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenParameter.time = $event)),
              type: "daterange",
              align: "right",
              "unlink-panels": "",
              "range-separator": "-",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              shortcuts: _ctx.shortcuts,
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenChange($event, 'time')))
            }, null, 8, ["modelValue", "shortcuts"])
          ]),
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_select, {
              class: "mar-r-8",
              style: {"width":"114px"},
              modelValue: _ctx.screenParameter.units_id,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenParameter.units_id = $event)),
              placeholder: "请选择",
              clearable: "",
              filterable: "",
              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectChange($event, 'units_id')))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.repairunit_data, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.repair_unit_name,
                    value: item.repair_unit_id,
                    key: item.repair_unit_id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_select, {
              modelValue: _ctx.screenParameter.partner_id,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.screenParameter.partner_id = $event)),
              class: "width-114 mar-l-8",
              clearable: "",
              filterable: "",
              placeholder: "请选择",
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectChange($event, 'partner_id')))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.partner_data, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_input, {
            style: {"width":"242px"},
            modelValue: _ctx.screenParameter.search,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.screenParameter.search = $event)),
            placeholder: "单据编号/车牌/送修人/手机",
            clearable: "",
            "suffix-icon": "el-icon-search",
            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectChange($event,'search')))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            class: "mar-l-9 bg-red",
            onClick: _ctx.exportChange
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            class: "mar-l-9 bg-red",
            onClick: _ctx.addBatchPayList
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.NavIndex == 2)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            class: "mar-l-9 bg-red",
            onClick: _ctx.removeClick
          }, {
            default: _withId(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            class: "mar-l-9 bg-red",
            onClick: _ctx.payTotalClick
          }, {
            default: _withId(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass,
      "show-summary": "",
      "summary-method": _ctx.getSummaries,
      onSelectionChange: _ctx.handleSelectionChange
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          label: "单据编号",
          align: "center",
          "min-width": "80"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              class: "text-center c-red purchaes_number",
              onClick: ($event: any) => (_ctx.getOrderCarinfo(scope.row))
            }, _toDisplayString(scope.row.ordersn), 9, ["onClick"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style", "summary-method", "onSelectionChange"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "批量回款",
      "model-value": _ctx.batchDialog_show,
      center: "",
      width: 1000,
      "before-close": ()=>{_ctx.batchDialog_show = false}
    }, {
      footer: _withId(() => [
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_el_button, {
            class: "bg-red mar-r-16",
            onClick: _ctx.batch_submit
          }, {
            default: _withId(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.batchDialog_show = false))
          }, {
            default: _withId(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _withDirectives(_createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.batchForm,
          rules: _ctx.form_rules,
          "label-width": "120px",
          style: {"width":"850px","margin":"0 auto"},
          inline: true
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, { label: "回款笔数" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.batchForm.batch_number), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "结算金额" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.batchForm.price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "待回款金额" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.batchForm.return_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "收入日期",
              prop: "pay_time"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.batchForm.pay_time,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.batchForm.pay_time = $event)),
                  type: "date",
                  style: {"width":"280px"},
                  placeholder: "选择日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "收款方式",
              prop: "pay_type"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择",
                  modelValue: _ctx.batchForm.pay_type,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.batchForm.pay_type = $event)),
                  clearable: "",
                  class: "mar-r-8",
                  style: {"width":"280px"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.zf, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.basicset_name,
                        value: item.basicset_id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "批量备注" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"400px"},
                  modelValue: _ctx.batchForm.desc,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.batchForm.desc = $event)),
                  type: "textarea",
                  row: "3",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "工单详情",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      onClosed: _ctx.handleClose,
      center: "",
      width: 1000
    }, {
      default: _withId(() => [
        _createVNode("table", _hoisted_21, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        (_ctx.orderDetail.order_offer_project.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.orderDetail.order_offer_project,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 1),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.order_offer_mountings.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: _ctx.orderDetail.order_offer_mountings,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 2),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.mountings_cost.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 2,
              data: _ctx.orderDetail.mountings_cost,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 3),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mountingsCostColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.else_cost.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 3,
              data: _ctx.orderDetail.else_cost,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 4),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.settlement.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 4,
              data: _ctx.orderDetail.settlement,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "header-cell-style"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"])
  ]))
})